var React = require('react');

function ChartLine (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31 24a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a2 2 0 0 1-2-2V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v19h27zM29 6c.552 0 1 .447.999 1v7.378c0 1.336-1.616 2.006-2.561 1.061l-2.025-2.025-6 6a2 2 0 0 1-2.828 0l-4.586-4.586-2.879 2.879a.999.999 0 0 1-1.414 0l-1.414-1.414a.999.999 0 0 1 0-1.414l4.293-4.293a2 2 0 0 1 2.828 0l4.586 4.586 4.586-4.586-2.025-2.025C19.615 7.616 20.284 6 21.621 6H29z"}));
}

ChartLine.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ChartLine;

ChartLine.default = ChartLine;
